import { Accordion } from "react-bootstrap";
import PageHeader from "../shared/PageHeader";

const accordionVariableData = {
  '--bs-accordion-btn-active-icon': `url("${window?.location?.origin}/Assets/Img/minimize-sign.png")`,
  '--bs-accordion-btn-icon': `url("${window?.location?.origin}/Assets/Img/plus.png")`,
}

const faqData = [
  {
    id: "1",
    question: "What is OwnFood?",
    answer: "OwnFood is a food delivery app that connects you with local home chefs and homemade food providers.",
  },
  {
    id: "2",
    question: "How do I order food on OwnFood?",
    answer: "To order food on OwnFood, simply download the app, create an account, and browse through the available home kitchens and homemade food options.",
  },
  {
    id: "3",
    question: "How long does it take to deliver food?",
    answer: "Delivery times vary depending on the home kitchen and your location. Once you place an order, you'll see an estimated delivery time.",
  },
  {
    id: "4",
    question: "How do I track my order?",
    answer: "After placing an order, you can track its progress in the app. You'll receive real-time updates on your order status.",
  },
  {
    id: "5",
    question: "How do I cancel my order?",
    answer: "To cancel an order, simply go to the 'Orders' section in the app and select the order you want to cancel. You can cancel the order before it's been picked up by the home chef.",
  },
  {
    id: "6",
    question: "How do I rate a home kitchen?",
    answer: "After completing an order, you'll have the option to rate and review the home kitchen. Your feedback helps others and improves the chef's profile.",
  },
  {
    id: "7",
    question: "How do I change my password?",
    answer: "To change your password, go to the 'Settings' section in the app, select 'Account', and then 'Change Password'. Follow the on-screen instructions to update your password.",
  },
  {
    id: "8",
    question: "How do I find a specific home kitchen or food item?",
    answer: "You can use the search bar at the top of the app to find specific home kitchens or food items. You can also use filters to narrow down your search.",
  },
  {
    id: "9",
    question: "How do I pay for my order?",
    answer: "OwnFood accepts various payment methods including credit/debit cards, digital wallets, and cash upon delivery.",
  },
  {
    id: "10",
    question: "How do I contact support?",
    answer: "You can contact our support team by clicking on the 'Contact Us' button in the app or by visiting our website and filling out the contact form.",
  },
  {
    id: "11",
    question: "Are there any hidden fees?",
    answer: "There are no hidden fees on OwnFood. The price you see is the price you pay.",
  },
  {
    id: "12",
    question: "How do I become a seller?",
    answer: "To become a seller, click on the 'Become a Seller' button in the app and follow the on-screen instructions to create a seller account.",
  },
  {
    id: "13",
    question: "How do I become a rider?",
    answer: "To become a rider, click on the 'Become a Rider' button in the app and follow the on-screen instructions to create a rider account.",
  },
];

export default function FAQPage() {
  return (
    <div className="container page-navbar-space">
      <PageHeader>Frequently Asked Questions</PageHeader>
      <div className="py-4">
        <p className="size-18 fw-normal text-muted" style={{ maxWidth: "900px" }}>
          If you have any questions about OwnFood, please check our frequently asked questions below. If you can't find the answer you're looking for, please contact us and we'll be happy to help.
          <br />
          We're here to help!
          <br />
          Thank you for choosing OwnFood!
        </p>
      </div>
      <div className="mx-auto mb-4">
        <Accordion defaultActiveKey="0" style={accordionVariableData}>
          {faqData.map((faq, index) => (
            <Accordion.Item eventKey={String(index)} key={faq.id}>
              <Accordion.Header style={{ fontWeight: 600 }}>{faq.question}</Accordion.Header>
              <Accordion.Body style={{ paddingLeft: '2rem', border: 0 }}>{faq.answer}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
